<div id="viewMode">
  <form [formGroup]="viewModeForm">
    Show:
    <input type="radio" id="radMap" value="map" name="viewMode" formControlName="viewMode" (change)="viewModeChange($event)" /><label class="ml-2 mr-2" for="radMap">Map</label>
    <input type="radio" id="radTable" value="table" name="viewMode" formControlName="viewMode"  (change)="viewModeChange($event)" /><label class="ml-2 mr-2" for="radTable">Table</label>
    <input type="radio" id="radBoth" value="both" name="viewMode" formControlName="viewMode"  (change)="viewModeChange($event)" checked="checked" /><label class="ml-2" for="radBoth">Both</label>
  </form>
</div>
<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="flex-grow-1">
  <div class="row summary-row">
    <div class="col-md-9 col-12">
      <app-summary-totals [summaryData]="summaryData"></app-summary-totals>
    </div>

    <div class="col-xxl-3 col-12">
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <div class="btn-group irregular-movements" role="group" aria-label="Irregular Movement Controls">
            <button type="button" class="btn btn-dark-lt" (click)="changeIrregularMovements(false)" [ngClass]="irregularMovements === false ? 'btn btn-purple hover-lift-light' : 'btn btn-white hover-lift-light'">Normal</button>
            <button type="button" class="btn btn-dark-lt" (click)="changeIrregularMovements(true)" [ngClass]="irregularMovements === true ? 'btn btn-purple hover-lift-light' : 'btn btn-white hover-lift-light'">Exception</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row flex-grow-1">
    <div [ngClass]="{'col-md-4 col-12 pr-1 flex-grow-1 d-flex flex-column' : showMode === 'both', 'd-none' : showMode === 'table', 'col-md-12 col-12 pr-1 flex-grow-1 d-flex flex-column' : showMode === 'map' }">
      <app-widget-in-transit-map [inTransit]="inTransit" [services]="services" [locationTypes]="locationTypes" [onlyShowLocations]="true" #inTransitMap></app-widget-in-transit-map>
    </div>
    <div [ngClass]="{'col-md-8 col-12 pl-1 flex-grow-1 d-flex flex-column' : showMode === 'both', 'd-none' : showMode === 'map', 'col-md-12 col-12 pl-1 flex-grow-1 d-flex flex-column' : showMode === 'table' }">
      <div class="row pt-2">
        <div  [ngClass]="{'col-12 active-filters' : showMode !== 'table', 'col-10 offset-2 active-filters' : showMode === 'table' }">
          @if (depots == null || depots.length > 1) {
            <mat-form-field appearance="fill" style="width: 20%" class="pr-1">
              <mat-label>Depot</mat-label>
              <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
                @for (depot of depots; track depot) {
                  <mat-option [value]="depot.id">{{depot.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <mat-form-field appearance="fill" style="width: 20%" class="pr-1">
            <mat-label>Vehicle</mat-label>
            <mat-select [(value)]="selectedVehicleId" (selectionChange)="vehicleChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
              @for (vehicle of customerVehicles; track vehicle) {
                <mat-option [value]="vehicle.id">{{vehicle.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 32%" class="pr-1">
            <mat-label>Location</mat-label>
            <mat-select [(value)]="selectedLocationId" (selectionChange)="locationChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
              @for (location of customerLocations; track location) {
                <mat-option [value]="location.id">{{location.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 28%" class="pr-1 pt-0">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
              <input matStartDate #startDate placeholder="Start date" [value]="selectedStartDate">
              <input matEndDate #endDate placeholder="End date" [value]="selectedEndDate" (dateChange)="selectedEndDateChange(startDate, endDate)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      <div appSetHeight class="col-12 pl-0 pr-0 flex-grow-1">
        <div class="h-60 overflow-auto">
          <app-widget-jobs [jobs]="jobs" [dashboardMode]="dashboardMode" (onExport)="exportJobsCSV()"></app-widget-jobs>
        </div>
        <div class="h-40 overflow-auto">
          <app-widget-services [services]="services" [dashboardMode]="dashboardMode" (onExport)="exportCustomerServicesCSV()"></app-widget-services>
        </div>
      </div>
    </div>
  </div>
</div>